<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">팀관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">팀 수정</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                팀 수정 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 80px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">부서명</th>
                  <td>
                    <select name="" id="" v-model="deptId" title="부서명 선택" class="md">
                      <option v-for="(item, index) in deptList" :key="index" :value="item.deptId">
                        {{ item.deptNm }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">팀 명</th>
                  <td>
                    <input type="text" title="팀명" class="md" v-model="teamNm" />
                    <p class="error" v-if="!$v.teamNm.required">필수 입력란입니다.</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row">팀 설명</th>
                  <td>
                    <textarea name="" id="" style="resize: none" v-model="teamDc"></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('teamlist')">목록</button>
          <button class="btn gray" @click="goBackConfirm">취소</button>
          <button class="btn blue" @click="updateBtn">저장</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import { required } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      listData: [],
      nodata: true,
      curPageNum: 1,
      dataPerPage: 10,
      deptId: '',
      teamDc: '',
      teamNm: '',
      submitStatus: '',
      deptList: [],
      teamId: '',
    };
  },
  validations: {
    teamNm: {
      required,
    },
  },
  created() {
    let data = this.$route.params.data;
    if (data === null) {
      data = JSON.parse(localStorage.getItem('teamManageData'));
    } else {
      localStorage.setItem('teamManageData', JSON.stringify(data));
    }
    //this.deptNm = data.deptNm;
    this.teamNm = data.teamNm;
    this.teamDc = data.teamDc;
    this.deptId = data.deptId;
    this.teamId = data.teamId;
  },

  components: {},

  mounted() {
    this.getDeptList();
  },

  methods: {
    async getDeptList() {
      const res = await axios('get', '/api/dept/list.json');
      this.deptList = res.data.resultList;
    },
    async updateBtn() {
      if (this.$v.$invalid) {
        return;
      }

      let apiParams = new FormData();

      apiParams.append('teamNm', this.teamNm);
      apiParams.append('teamDc', this.teamDc);
      apiParams.append('deptId', this.deptId);
      apiParams.append('teamId', this.teamId);
      await axios('post', '/api/team/updateAction.json', apiParams)
        .then(response => {
          let message = response.data.message;
          alert(message);

          this.$router.push('teamlist');
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    goBack() {
      this.$router.go(-1);
      localStorage.clear();
    },
    goBackConfirm() {
      this.$confirm({
        message: `취소하시겠습니까?`,
        button: {
          no: '아니오',
          yes: '예',
        },
        callback: confirm => {
          if (confirm) {
            this.goBack();
          }
        },
      });
    },
  },

  computed: {},
};
</script>
